import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';
import * as R from 'ramda';
import { Requirement } from '../models';
import { AppState } from '../../core/redux/appState';


const KEY_ACTION = ActionType.LoadParticipantRequirementsRequest;
const ACTIONS    = [
  ActionType.LoadParticipantRequirementsRequest,
  ActionType.LoadParticipantRequirementsResponse,
  ActionType.LoadParticipantRequirementsError,
];


type Payload = Requirement[];

type Meta = {
  projectId: number,
  participantId: number,
};


/**
 * Dispatch this action to load the set of requirements for project participants
 * e.g. do they have to do the self survey? How about the Development Plan?
 */
export const loadParticipantRequirementsAction = (
  projectId: number,
  participantId: number,
  languageId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.ParticipantRequirements,
  headers:  { 'content-type': 'application/json' },
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  body:     (state: AppState) => JSON.stringify(
    {
      projectId: projectId,
      participantId: participantId,
      languageId: state.locale.lang.languageId,
    },
  ),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assoc('participantRequirements', payload, successState);
};


export const loadParticipantRequirementsReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
